import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
const Button = ({ loading = false, isSubmit, type = isSubmit ? "submit" : "button", role = "primary", onClick, isBlock, id, className, children, disabled = false, style, }) => {
    const buttonClasses = classNames([
        "btn",
        className,
        { "btn-primary": role === "primary" },
        { "btn-secondary": role === "secondary" },
        { "btn-block": isBlock },
        { "btn-submit": isSubmit },
    ]);
    return (_jsxs("button", { type: type, className: buttonClasses, disabled: loading || disabled, onClick: onClick, id: id, style: style, children: [loading && (_jsxs(_Fragment, { children: [_jsx("span", { className: "spinner-border spinner-border-sm mr-1", role: "status", "aria-hidden": "true" }), "Loading..."] })), !loading && _jsx(_Fragment, { children: children })] }));
};
export default Button;
